import { render, staticRenderFns } from "./LtcatLegalInterpretationModal.vue?vue&type=template&id=3ee7c417&"
import script from "./LtcatLegalInterpretationModal.vue?vue&type=script&lang=js&"
export * from "./LtcatLegalInterpretationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports